import { resolveApiUrl } from "~/utils/url/urlResolver";
import { registerCallProcessor, scheduleCall } from "~/features/cart/cart/api/CartService";
import { apiGET } from "~/app/api/apiCallsService";
import type { PriceData } from "~/domains/pricing/types/PriceData";

const URL = resolveApiUrl("/cart/miniCart");

interface MinicartWSResponse {
  miniCartCount: number;
  miniCartPrice?: PriceData;
}

export async function fetchMinicart(): Promise<MinicartWSResponse> {
  const response = await scheduleCall("miniCart", {});
  return response.json();
}

registerCallProcessor({
  type: "miniCart",
  execute: async () => {
    return apiGET(URL, {
      credentials: "same-origin",
      mode: "cors",
    });
  },
  canBeExecuted: (ongoingCalls) => {
    const isDeleteOngoing = ongoingCalls.some((call) => call.type === "delete" || call.type === "deleteCart");
    return !isDeleteOngoing;
  },
});
